import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Slide,
  useScrollTrigger,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  MobileStepper,
  useMediaQuery
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MenuIcon from "@mui/icons-material/Menu";

const clientMongoId = localStorage.getItem("clientMongoId");
const studioName = localStorage.getItem("studioName") ;

const NAV_LINKS = [
  { label: "Home", path: "/user-home" },
  { label: "Albums", path: "/user-albums" },
  { label: "Frames", path: "/user-frames" },
  { label: "Photo Selection", path: "/user-photo-selection" },
  { label: "Prices", path: "/user-prices" },
  { label: "Contact", path: "/user-contact" },
  { label: "About", path: "/user-about" }
];

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

function UserPrice() {
  const [priceData, setPriceData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [footers, setFooters] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  

  useEffect(() => {
    async function fetchPrices() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/prices`);
        setPriceData(res.data.prices && res.data.prices.length > 0 ? res.data.prices : []);
      } catch (err) {
        setPriceData([]);
      }
    }
    fetchPrices();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchFooters() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`
        );
        setFooters(res.data.footers || {});
      } catch (err) {
        setFooters({});
      }
    }
    fetchFooters();
  }, [clientMongoId]);

  const handleCardClick = (idx) => {
    setSelectedIdx(idx);
    setActiveStep(0);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedIdx(null);
    setActiveStep(0);
  };

  const handleNext = () => {
    if (selectedIdx !== null) {
      setActiveStep((prev) => Math.min(prev + 1, priceData[selectedIdx].packages.length - 1));
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  return (
       <Box
          sx={{
            bgcolor: "#fff",
            minHeight: "100vh",
            width: "100%",
            overflowX: "hidden"
          }}
        >
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#fff",
            boxShadow: 3,
            height: isMobile ? 56 : 80,
            zIndex: 1201,
          }}
        >
          <Toolbar
            sx={{
              minHeight: isMobile ? 56 : 80,
              px: isMobile ? 1 : 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isMobile ? "space-between" : "center",
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
             fontFamily: "josefin Sans",
                fontWeight: 900,
                color: "#8b5e3c",
                letterSpacing: 2,
                mr: isMobile ? 0 : 4,
                flexShrink: 0
              }}
            >
              {studioName}
            </Typography>
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 4,
                  flexGrow: 1,
                }}
              >
                {NAV_LINKS.map((link) => (
                  <Button
                    key={link.label}
                    href={link.path}
                    sx={{
                      color: "#8b5e3c",
                      fontWeight: 700,
                      fontFamily: "josefin Sans",
                      fontSize: 22,
                      textTransform: "none",
                      letterSpacing: 1.5,
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {isMobile && (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: "auto" }}
              >
                <MenuIcon sx={{ color: "#8b5e3c", fontSize: 36,fontFamily: "josefin Sans", }} />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 220, mt: 6 }}>
          <List>
            {NAV_LINKS.map((link) => (
              <ListItem
                button
                key={link.label}
                component="a"
                href={link.path}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: "#8b5e3c",
                    fontFamily: "josefin Sans",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Box sx={{ height: isMobile ? 56 : 80 }} />
      <Box
        sx={{
          bgcolor: "#e7dfd5",
          borderRadius: 4,
          py: 5,
          mb: 4,
          boxShadow: 2,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: "#8b5e3c",
            textAlign: "center",
            fontFamily: "josefin Sans",
            letterSpacing: 2,
            mb: 1,
          }}
        >
          Price List
        </Typography>
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            color: "#5c4032",
            fontFamily: "jost",
            fontWeight: 400,
            mb: 2,
          }}
        >
          Explore our packages and find the perfect fit for your special day.
        </Typography>
      </Box>
      <Grid container spacing={4} justifyContent="center">
        {priceData.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Card
              sx={{
                borderRadius: 4,
                boxShadow: 4,
                width: isMobile ? 320 : 340,
                height: isMobile ? 370 : 410,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "stretch",
                position: "relative",
                transition: "transform 0.3s",
                background: "linear-gradient(120deg,#fff 60%,#e7dfd5 100%)",
                "&:hover": { transform: "scale(1.04)", boxShadow: 8, background: "linear-gradient(120deg,#e3f2fd 60%,#e7dfd5 100%)" }
              }}
            >
              {/* Image always at the top */}
              <Box sx={{ width: "100%", height: isMobile ? 140 : 180, overflow: "hidden", borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
                <img
                  src={item.img}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16
                  }}
                  onClick={() => handleCardClick(idx)}
                />
              </Box>
              <CardContent
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  p: 2,
                  cursor: "pointer"
                }}
                onClick={() => handleCardClick(idx)}
              >
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  sx={{
                    fontWeight: 700,
                    color: "#8b5e3c",
                    textAlign: "center",
                   fontFamily: "josefin Sans",
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    fontWeight: 700,
                    color: "#1976d2",
                   fontFamily: "josefin Sans",
                    mb: 1
                  }}
                >
                  {item.priceRange}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Price Details Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 8,
            bgcolor: "#fff"
          }
        }}
      >
        {selectedIdx !== null && (
          <>
            {/* Image at the top */}
            <Box sx={{ width: "100%", height: 180, overflow: "hidden", borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
              <img
                src={priceData[selectedIdx].img}
                alt={priceData[selectedIdx].title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16
                }}
              />
            </Box>
            <DialogTitle
              sx={{
                fontWeight: 700,
                color: "#8b5e3c",
                textAlign: "center",
                fontSize: 28,
               fontFamily: "josefin Sans",
                letterSpacing: 2
              }}
            >
              {priceData[selectedIdx].title} Packages
            </DialogTitle>
            <DialogContent>
              <Box sx={{ textAlign: "center", mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: "#1976d2", fontFamily: "jost" }}>
                  {priceData[selectedIdx].packages[activeStep].model}
                </Typography>
                <Typography variant="h6" sx={{ color: "#8b5e3c", fontWeight: 700, fontFamily: "jost" }}>
                  {priceData[selectedIdx].packages[activeStep].amount}
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ fontWeight: 600, fontFamily: "jost" }}>
                Photographer: <span style={{ fontWeight: 400 }}>{priceData[selectedIdx].packages[activeStep].photographer}</span>
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, fontFamily: "jost", }}>
                Camera/Resolution: <span style={{ fontWeight: 400 }}>{priceData[selectedIdx].packages[activeStep].camera}</span>
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, fontFamily: "jost", }}>
                Time: <span style={{ fontWeight: 400 }}>{priceData[selectedIdx].packages[activeStep].time}</span>
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, fontFamily: "jost", }}>
                Videographer: <span style={{ fontWeight: 400 }}>{priceData[selectedIdx].packages[activeStep].videographer}</span>
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600, fontFamily: "jost", }}>
                Other Details: <span style={{ fontWeight: 400 }}>{priceData[selectedIdx].packages[activeStep].details}</span>
              </Typography>
              <MobileStepper
                variant="dots"
                steps={priceData[selectedIdx].packages.length}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <IconButton
                    onClick={handleNext}
                    disabled={activeStep === priceData[selectedIdx].packages.length - 1}
                  >
                    <ArrowForwardIosIcon />
                  </IconButton>
                }
                backButton={
                  <IconButton
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    <ArrowBackIosNewIcon />
                  </IconButton>
                }
                sx={{ justifyContent: "center", mt: 2 }}
              />
            </DialogContent>
            <Box sx={{ textAlign: "center", pb: 2,fontFamily: "jost" }}>
              <Button onClick={handleClose}>Close</Button>
            </Box>
          </>
        )}
      </Dialog>
     {/* Footer Section */}
             {/* Footer Section */}
                      <Box
                             sx={{
                               bgcolor: "#a67c52",
                               color: "#fff",
                                fontFamily: "Josefin Sans",
                               mt: 4,
                               pt: 4,
                               pb: 2
                             }}
                           >
                             <Grid container spacing={2} sx={{ maxWidth: 1300, mx: "auto" }}>
                               {/* Left Column */}
                               <Grid item xs={12} md={3} sx={{ml: { xs: 3 }, mt: { xs: 6,  }}}>
                                 <Typography variant="h5" sx={{ fontWeight: 700,  fontFamily: "Josefin Sans",  }}>
                                   {footers.studio}
                                 </Typography>
                                 <Typography variant="body1" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.tag}</Typography>
                                 <Typography variant="body2" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.handle}</Typography>
                               </Grid>
                               {/* Center Column */}
                               <Grid
                                 item
                                 xs={12}
                                 md={6}
                                 sx={{
                                   display: "flex",
                                   flexDirection: "column",
                                   alignItems: "center",
                                   justifyContent: "center",
                                   ml: { xs: 0, md: 12 }
                                 }}
                               >
                                 <Typography
                                   variant="body1"
                                   sx={{
                                     textAlign: "center",
                                     fontSize: 18,
                                     mb: 2,
                                     fontFamily: "Jost",
                                   }}
                                 >
                                   {footers.text}
                                 </Typography>
                               </Grid>
                               {/* Right Column */}
                               <Grid item xs={12} md={3}>
                                 <Box sx={{ display: "flex", gap: 2, mb: 2,ml: { xs: 3, md: 15 } ,mt: { xs: 6, md: 5 } }}>
                                   {/* WhatsApp */}
                                   <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                                     <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                                       <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                                     </Box>
                                   </a>
                                   {/* Instagram */}
                                   <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                                     <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                       <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                                     </Box>
                                   </a>
                                   {/* Gmail */}
                                   <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                                     <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                       <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                                     </Box>
                                   </a>
                                   {/* YouTube */}
                                   <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                                     <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                       <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                                     </Box>
                                   </a>
                                 </Box>
                               </Grid>
                               {/* Bottom Row */}
                               <Grid
                                 item
                                 xs={12}
                                 sx={{
                                   borderTop: "1px solid #fff2",
                                   mt: 0,
                                   ml: {xs:5, md:50},
                                   pt: 2,
                                   display: "flex",
                                   flexDirection: { xs: "column", md: "row" },
                                   justifyContent: "space-between",
                                   alignItems: "center"
                                 }}
                               >
                                 <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                                   {footers.copyright}
                                 </Typography>
                                 <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                                   {footers.made}
                                 </Typography>
                               </Grid>
                             </Grid>
                           </Box>
    </Box>
  );
}

export default UserPrice;